import { SubmitSupplementKnowledgeBody } from 'services/api/supplementKnowledge';
// 暂存创建知识库的请求
export const queueMap: Map<
  Conversation.Conversation['conversationId'],
  SubmitSupplementKnowledgeBody
> = new Map();
